export default {
	// Config
	apiKey: "AIzaSyD_LmY8t1_lf5j-odqEcEjbEsKGi4xW3ag",
  authDomain: "crown-mytrace.firebaseapp.com",
  projectId: "crown-mytrace",
  storageBucket: "crown-mytrace.firebasestorage.app",
  messagingSenderId: "760020884129",
  appId: "1:760020884129:web:5195b8155acec67009eee0"
};
